import styled from "styled-components";
import { defaultThemeColors } from "ui/theme";

const steps = [
  {
    id: 1,
    title: "Discover Classes",
    description: "Browse a variety of classes taught by passionate instructors",
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="17"
          cy="17"
          r="10"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="2"
          y1="17"
          x2="6"
          y2="17"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <line
          x1="28"
          y1="17"
          x2="32"
          y2="17"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <line
          x1="17"
          y1="2"
          x2="17"
          y2="6"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <line
          x1="17"
          y1="28"
          x2="17"
          y2="32"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <ellipse
          cx="17"
          cy="17"
          rx="5"
          ry="10"
          stroke="#1D1D1F"
          strokeWidth="1.8"
        />
        <path
          d="M25 25L32 32"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  {
    id: 2,
    title: "Choose Your Instructor",
    description:
      "Explore instructor profiles, read reviews, and select the class that fits you best",
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="20"
          cy="13"
          r="6"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 35C8 28.373 13.373 23 20 23C26.627 23 32 28.373 32 35"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27 18L29 20L34 15"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: 3,
    title: "Book Your Spot",
    description:
      "Reserve your place in just a few clicks and get all the details you need for the class",
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="6"
          y="9"
          width="28"
          height="26"
          rx="3"
          stroke="#1D1D1F"
          strokeWidth="1.8"
        />
        <path
          d="M6 16H34"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M14 6V12"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M26 6V12"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <circle cx="13" cy="24" r="1.5" fill="#1D1D1F" />
        <circle cx="20" cy="24" r="1.5" fill="#1D1D1F" />
        <circle cx="27" cy="24" r="1.5" fill="#1D1D1F" />
        <circle cx="13" cy="30" r="1.5" fill="#1D1D1F" />
        <circle cx="20" cy="30" r="1.5" fill="#1D1D1F" />
      </svg>
    ),
  },
  {
    id: 4,
    title: "Learn & Enjoy",
    description:
      "Join the class, learn new skills, and connect with a community that shares your interests",
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="20"
          cy="13"
          r="6"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 19V26"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M14 34L20 26L26 34"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 8L10 5"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M27 8L30 5"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M9 13H6"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M31 13H34"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M16 30H10"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M24 30H30"
          stroke="#1D1D1F"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
];

export const HowItWorks = () => {
  return (
    <Section>
      <Grid>
        {steps.map((step) => (
          <Step key={step.id}>
            <IconWrap>{step.icon}</IconWrap>
            <TextBlock>
              <Title>{step.title}</Title>
              <Desc>{step.description}</Desc>
            </TextBlock>
          </Step>
        ))}
      </Grid>
    </Section>
  );
};

const Section = styled.section`
  width: 100%;
  background: #ffffff;
  box-sizing: border-box;
  margin-bottom: 150px;
  padding-inline:1rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 32px 20px;
  }

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 20px;

  @media (max-width: 1024px) {
    gap: 14px;
  }
`;

const IconWrap = styled.div`
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background-color: #f7f5f1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    width: 64px;
    height: 64px;

    svg {
      width: 28px;
      height: 28px;
    }
  }
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  @media (max-width: 1024px) {
    gap: 6px;
  }
`;

const Title = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: ${defaultThemeColors.basicBlack};
  margin: 0;
  line-height: 1.3;

  @media (max-width: 1024px) {
    font-size: 16px;
  }
`;

const Desc = styled.p`
  font-size: 14px;
  font-weight: 300;
  color: #4b4b4b;
  margin: 0;
  line-height: 1.6;
  max-width: 220px;

  @media (max-width: 1024px) {
    font-size: 13px;
    max-width: 100%;
  }
`;
